"use client";

import { useEffect, useState } from "react";

export default function ArticleDate({
  value,
  includeTime = false,
  locale,
}: {
  value?: string;
  includeTime?: boolean;
  locale?: string;
}) {
  const [formatted, setFormatted] = useState("");
  useEffect(() => {
    const date = new Date(value ?? "");
    setFormatted(
      Number.isFinite(date.getTime())
        ? new Intl.DateTimeFormat(locale, {
            dateStyle: "long",
            ...(includeTime ? { timeStyle: "short" as const } : {}),
          }).format(date)
        : "",
    );
  }, [value, includeTime, locale]);
  return <time dateTime={value}>{formatted}</time>;
}
